/*
 * Loads enhancement-only scripts for below-fold Lifetime Leash PDP sections.
 * Content remains server rendered; only slider/video behavior waits until its
 * owning section is about to enter the viewport.
 */
(function () {
  'use strict';

  var selector = '[data-apc-pdp-defer-src]';
  var afterPaintSelector = '[data-apc-after-paint-src]';
  var loaded = Object.create(null);

  function absoluteUrl(src) {
    try {
      return new URL(src, document.baseURI).href;
    } catch (error) {
      return src;
    }
  }

  function hasScript(src) {
    var url = absoluteUrl(src);

    return loaded[url] || Array.prototype.some.call(document.scripts, function (script) {
      return script.src === url;
    });
  }

  function load(src) {
    if (!src || hasScript(src)) return;

    var url = absoluteUrl(src);
    var script = document.createElement('script');

    loaded[url] = true;
    script.src = src;
    script.async = false;
    script.setAttribute('data-apc-pdp-deferred-loaded', '');
    document.head.appendChild(script);
  }

  function observe(placeholder) {
    var src = placeholder.getAttribute('data-apc-pdp-defer-src');
    var section = placeholder.closest('.shopify-section');

    if (!section || !('IntersectionObserver' in window)) {
      load(src);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        observer.disconnect();
        load(src);
      });
    }, {
      rootMargin: '150px 0px',
      threshold: 0
    });

    observer.observe(section);
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(observe);
  }

  function initializeAfterPaint() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        document.querySelectorAll(afterPaintSelector).forEach(function (placeholder) {
          load(placeholder.getAttribute('data-apc-after-paint-src'));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize();
      initializeAfterPaint();
    }, { once: true });
  } else {
    initialize();
    initializeAfterPaint();
  }
})();
